import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchDocumentation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 108,
	height: 95,
	viewBox: "0 0 108 95",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 44.5,
			cy: 39.5,
			r: 39.5,
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 39.5,
			cy: 39.5,
			r: 38.75,
			fill: "#F4F4F4",
			stroke: "#A0A0A0",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.5 20C87.8807 20 89 18.8807 89 17.5C89 16.1193 87.8807 15 86.5 15C85.1193 15 84 16.1193 84 17.5C84 18.8807 85.1193 20 86.5 20Z",
			fill: "#C2C2C2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79 8C81.2091 8 83 6.20914 83 4C83 1.79086 81.2091 0 79 0C76.7909 0 75 1.79086 75 4C75 6.20914 76.7909 8 79 8Z",
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36 89C38.2091 89 40 87.2091 40 85C40 82.7909 38.2091 81 36 81C33.7909 81 32 82.7909 32 85C32 87.2091 33.7909 89 36 89Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 85C17.1046 85 18 84.1046 18 83C18 81.8954 17.1046 81 16 81C14.8954 81 14 81.8954 14 83C14 84.1046 14.8954 85 16 85Z",
			fill: "#B6B6B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.625 43.175V51.05C52.625 61.55 48.425 65.75 37.925 65.75H27.95C17.45 65.75 13.25 61.55 13.25 51.05V41.075C13.25 30.575 17.45 26.375 27.95 26.375H35.825",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.6242 43.175H44.2242C37.9242 43.175 35.8242 41.075 35.8242 34.775V26.375L52.6242 43.175Z",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.4492 13.25H48.9492",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.375 21.125C26.375 16.7675 29.8925 13.25 34.25 13.25H41.1275",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.7493 29V45.2487C65.7493 49.3175 62.4418 52.625 58.373 52.625",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.75 29H57.875C51.9688 29 50 27.0312 50 21.125V13.25L65.75 29Z",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.376 87.3755L89.3371 76.3371L100.376 87.3755ZM89.3371 76.3371C91.2252 74.4489 92.723 72.2073 93.7449 69.7403C94.7668 67.2733 95.2927 64.6291 95.2927 61.9589C95.2927 59.2886 94.7668 56.6444 93.7449 54.1774C92.723 51.7104 91.2252 49.4688 89.3371 47.5806C87.4489 45.6925 85.2073 44.1947 82.7403 43.1728C80.2733 42.151 77.6291 41.625 74.9589 41.625C72.2886 41.625 69.6444 42.151 67.1774 43.1728C64.7104 44.1947 62.4688 45.6925 60.5806 47.5806C56.7673 51.394 54.625 56.566 54.625 61.9589C54.625 67.3517 56.7673 72.5237 60.5806 76.3371C64.394 80.1504 69.566 82.2927 74.9589 82.2927C80.3517 82.2927 85.5237 80.1504 89.3371 76.3371Z",
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.376 87.3755L89.3371 76.3371M89.3371 76.3371C91.2252 74.4489 92.723 72.2073 93.7449 69.7403C94.7668 67.2733 95.2927 64.6291 95.2927 61.9589C95.2927 59.2886 94.7668 56.6444 93.7449 54.1774C92.723 51.7104 91.2252 49.4688 89.3371 47.5806C87.4489 45.6925 85.2073 44.1947 82.7403 43.1728C80.2733 42.151 77.6291 41.625 74.9589 41.625C72.2886 41.625 69.6444 42.151 67.1774 43.1728C64.7104 44.1947 62.4688 45.6925 60.5806 47.5806C56.7673 51.394 54.625 56.566 54.625 61.9589C54.625 67.3517 56.7673 72.5237 60.5806 76.3371C64.394 80.1504 69.566 82.2927 74.9589 82.2927C80.3517 82.2927 85.5237 80.1504 89.3371 76.3371Z",
			stroke: "#A0A0A0",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.2085 62.0056C90.199 65.0227 89.2948 67.9693 87.6103 70.4724C85.9258 72.9755 83.5367 74.9227 80.7452 76.0676C77.9537 77.2124 74.8853 77.5034 71.9284 76.9039C68.9714 76.3043 66.2588 74.8411 64.1337 72.6993C62.0086 70.5576 60.5665 67.8335 59.99 64.872C59.4135 61.9104 59.7284 58.8444 60.8949 56.0619C62.0614 53.2794 64.0271 50.9054 66.5432 49.2404C69.0593 47.5754 72.0128 46.6941 75.0299 46.7082C77.0335 46.7069 79.0176 47.1026 80.8674 47.8724C82.7173 48.6422 84.3963 49.7708 85.8076 51.1932C87.2189 52.6155 88.3344 54.3033 89.0897 56.1591C89.8451 58.0149 90.2253 60.002 90.2085 62.0056ZM87.7029 61.9879C87.7058 59.4681 86.962 57.004 85.5655 54.9066C84.1691 52.8093 82.1825 51.1727 79.8566 50.2036C77.5307 49.2344 74.9698 48.9763 72.4973 49.4615C70.0247 49.9468 67.7514 51.1538 65.9643 52.9301C64.1772 54.7065 62.9565 56.9725 62.4564 59.4421C61.9562 61.9117 62.1989 64.4742 63.154 66.8059C64.109 69.1377 65.7335 71.1341 67.8224 72.5432C69.9113 73.9524 72.3708 74.711 74.8905 74.7233C76.5735 74.7483 78.2444 74.4365 79.8051 73.8063C81.3658 73.1761 82.7847 72.2401 83.9784 71.0536C85.1722 69.867 86.1167 68.4538 86.7563 66.8969C87.3959 65.34 87.7177 63.6709 87.7029 61.9879Z",
			fill: "#646464"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.5007 52.9957C77.5007 53.7175 76.8571 54.2122 75.7593 54.2352C74.2219 54.2764 72.7229 54.6618 71.408 55.3539C70.845 55.6588 70.3174 56.0103 69.8325 56.4035C69.0266 57.0218 68.2638 57.0275 67.6801 56.4495C67.5499 56.3186 67.4528 56.1654 67.3951 56C67.3373 55.8345 67.3203 55.6605 67.345 55.4889C67.3696 55.3174 67.4355 55.1522 67.5384 55.0041C67.6412 54.856 67.7787 54.7283 67.942 54.6291C70.0807 52.8385 72.9291 51.8259 75.9019 51.7994C76.0989 51.7807 76.2982 51.7974 76.4874 51.8484C76.6766 51.8994 76.8516 51.9836 77.0016 52.0959C77.1515 52.2081 77.2732 52.3459 77.3591 52.5007C77.4449 52.6555 77.4932 52.824 77.5007 52.9957Z",
			fill: "#646464"
		})
	]
});
export default SvgSearchDocumentation;
